module.exports = __webpack_public_path__ + "static/media/Low-carbon-hydrogen.ef2aaeba.svg";